import { render, staticRenderFns } from "./ApproveRxAuthWithChanges.vue?vue&type=template&id=5ea5ef03"
import script from "./ApproveRxAuthWithChanges.vue?vue&type=script&lang=js"
export * from "./ApproveRxAuthWithChanges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports